export const budgetChartProps = {
  keys: ["Budget", "Cost"],
  groupMode: "grouped",
};
